import styled from 'styled-components';
const boxShadowBase = (props) => `${props.theme.SizeShadowButtonActive} ${props.theme.ColorShadowButtonActive}`;
const boxShadowGrey = (props) => `${props.theme.SizeShadowButtonActive} ${props.theme.ColorShadowButtonGreyActive}`;
const boxShadowDestructive = (props) => `${props.theme.SizeShadowButtonActive} ${props.theme.ColorShadowButtonErrorActive}`;
const BaseBtnSC = styled.button.attrs((p) => {
    return {
        disabled: p.disabled
    };
}) `
  user-select: none;

  box-sizing: border-box;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  min-width: ${(props) => props.theme.SizeWidthButtonDefaultBase};
  min-height: ${(props) => props.theme.SizeHeightButtonDefaultBase};
  max-width: 100%;
  width: auto;
  margin: 0.5rem 0.75rem 0.5rem;
  padding: 0 ${(props) => props.theme.SizePaddingButtonDefaultBase};
  white-space: nowrap;

  border: ${(props) => props.theme.SizeBorderWidthDefault} solid transparent;
  border-radius: ${(props) => props.theme.SizeBorderRadiusButtonBase};

  font-family: ${(props) => props.theme.FontFamilyBase};
  font-size: ${(props) => props.theme.SizeFontButtonDefaultBase};
  line-height: ${(props) => props.theme.SizeLineHeightButtonDefaultBase};
  font-weight: ${(props) => props.theme.ContentFontWeightButtonDefault};
  text-align: center;

  color: ${(props) => props.theme.ColorFontButtonDefaultBase};
  background-color: transparent;

  will-change: border, color, box-shadow, background-color, min-width, height;
  transition: border 0.3s, color 0.3s, box-shadow 0.3s, background-color 0.3s,
    min-width 0.1s, height 0.1s;

  & > div {
    flex: 0 0 auto;
  }

  &._ndsBtn--compact {
    margin: 0 !important;
  }

  &._ndsBtn--medium {
    min-height: ${(props) => props.theme.SizeHeightButtonDefaultMedium};
    padding: 0 ${(props) => props.theme.SizePaddingButtonDefaultMedium};

    font-size: ${(props) => props.theme.SizeFontButtonDefaultMedium};
    line-height: ${(props) => props.theme.SizeLineHeightButtonDefaultMedium};
  }

  &._ndsBtn--large {
    min-width: ${(props) => props.theme.SizeWidthButtonDefaultLarge};
    min-height: ${(props) => props.theme.SizeHeightButtonDefaultLarge};
    padding: 0 ${(props) => props.theme.SizePaddingButtonDefaultLarge};

    font-size: ${(props) => props.theme.SizeFontButtonDefaultLarge};
    line-height: ${(props) => props.theme.SizeLineHeightButtonDefaultLarge};
  }

  &._ndsBtn--fluid {
    min-width: ${(props) => props.theme.SizeWidthButtonDefaultFluid};
    width: 100%;
    margin: 0.5rem 0;
  }

  &:focus {
    outline: 0;
  }

  :hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.ColorBackgroundButtonDefaultHover};
  }

  :focus,
  :active {
    background-color: ${(props) => props.theme.ColorBackgroundButtonDefaultActive};
  }

  &._ndsBtn--grey:focus,
  &._ndsBtn--grey:active {
    background-color: ${(props) => props.theme.ColorBackgroundButtonDefaultGreyActive};
  }

  &._ndsBtn--destructive:focus,
  &._ndsBtn--destructive:active {
    background-color: ${(props) => props.theme.ColorBackgroundButtonDefaultErrorActive};
  }

  ::before {
    content: '';
    position: absolute;
    top: -0.0625rem;
    left: -0.0625rem;
    width: calc(100% + 0.125rem);
    min-height: 2.25rem;
    border-radius: ${(props) => props.theme.SizeBorderRadiusButtonBase};
    box-shadow: none;

    will-change: box-shadow;
    transition: box-shadow 0.3s;
  }

  &._ndsBtn--medium::before {
    min-height: ${(props) => props.theme.SizeHeightButtonDefaultMedium};
  }

  &._ndsBtn--large::before {
    min-height: ${(props) => props.theme.SizeHeightButtonDefaultLarge};
  }

  :focus::before,
  :active::before {
    box-shadow: ${boxShadowBase};
  }

  &._ndsBtn--grey:focus::before,
  &._ndsBtn--grey:active::before {
    box-shadow: ${boxShadowGrey};
  }

  &._ndsBtn--destructive:focus::before,
  &._ndsBtn--destructive:active::before {
    box-shadow: ${boxShadowDestructive};
  }

  :disabled {
    cursor: not-allowed;
    background-color: ${(props) => props.theme.ColorBackgroundButtonDefaultDisabled};
    color: ${(props) => props.theme.ColorFontButtonDefaultDisabled};
  }

  &._ndsBtn--loading .icon {
    height: ${(props) => props.theme.SizeHeightIconButtonDefaultBase};
    margin-right: ${(props) => props.theme.SizeMarginIconButtonIconRightBase};
  }

  &._ndsBtn--loading._ndsBtn--medium .icon,
  &._ndsBtn--loading._ndsBtn--large .icon {
    height: ${(props) => props.theme.SizeHeightIconButtonDefaultLarge};
    margin-right: ${(props) => props.theme.SizeMarginIconButtonIconRightLarge};
  }

  &._ndsBtn--loading:disabled {
    cursor: progress;
    background-color: ${(props) => props.theme.ColorBackgroundButtonDefaultLoading};
    color: ${(props) => props.theme.ColorFontButtonDefaultLoading};
  }

  & > svg._ndsIcon {
    width: ${(props) => props.theme.SizeHeightIconButtonDefaultBase};
    min-width: ${(props) => props.theme.SizeHeightIconButtonDefaultBase};
    max-width: ${(props) => props.theme.SizeHeightIconButtonDefaultBase};
    height: ${(props) => props.theme.SizeWidthIconButtonDefaultBase};
    min-height: ${(props) => props.theme.SizeWidthIconButtonDefaultBase};
    max-height: ${(props) => props.theme.SizeWidthIconButtonDefaultBase};
    margin-right: 0.25rem;
  }

  &._ndsBtn--icon > svg._ndsIcon {
    width: ${(props) => props.theme.SizeHeightIconButtonIconBase};
    min-width: ${(props) => props.theme.SizeHeightIconButtonIconBase};
    max-width: ${(props) => props.theme.SizeHeightIconButtonIconBase};
    height: ${(props) => props.theme.SizeWidthIconButtonIconBase};
    min-height: ${(props) => props.theme.SizeWidthIconButtonIconBase};
    max-height: ${(props) => props.theme.SizeWidthIconButtonIconBase};
    margin-right: 0;
  }

  &._ndsBtn--medium > svg._ndsIcon,
  &._ndsBtn--large > svg._ndsIcon {
    width: ${(props) => props.theme.SizeHeightIconButtonDefaultLarge};
    min-width: ${(props) => props.theme.SizeHeightIconButtonDefaultLarge};
    max-width: ${(props) => props.theme.SizeHeightIconButtonDefaultLarge};
    height: ${(props) => props.theme.SizeWidthIconButtonDefaultLarge};
    min-height: ${(props) => props.theme.SizeWidthIconButtonDefaultLarge};
    max-height: ${(props) => props.theme.SizeWidthIconButtonDefaultLarge};
    margin-right: ${(props) => props.theme.SizeMarginIconButtonIconRightLarge};
  }

  &._ndsBtn--large._ndsBtn--icon > svg._ndsIcon {
    width: ${(props) => props.theme.SizeHeightIconButtonIconLarge};
    min-width: ${(props) => props.theme.SizeHeightIconButtonIconLarge};
    max-width: ${(props) => props.theme.SizeHeightIconButtonIconLarge};
    height: ${(props) => props.theme.SizeWidthIconButtonIconLarge};
    min-height: ${(props) => props.theme.SizeWidthIconButtonIconLarge};
    max-height: ${(props) => props.theme.SizeWidthIconButtonIconLarge};
    margin-right: 0;
  }

  & > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonDefaultBase};

    will-change: fill;
    transition: fill 0.3s;
  }

  :disabled > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonDefaultDisabled};
  }
`;
export default BaseBtnSC;
//# sourceMappingURL=BaseBtnSC.js.map